import React, { useState } from 'react';
import expedienteService from '../services/expedienteService';
import './CreateExpedienteModal.css';

const CreateExpedienteModal = ({ onClose, onSuccess, statusEnums }) => {
  const [formData, setFormData] = useState({
    cliente_status: 'Activo',
    expediente_status: 'En espera',
    informacion: {
      sede: '', nombre: '', apellido: '', contrato: '', cedula: '',
      telefono: '', email: '', modelo_contrato: '', status: '',
    },
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      await expedienteService.createExpediente(formData);
      onSuccess();
    } catch (err) {
      setError(err.response?.data?.detail || 'Error al crear expediente');
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (field, value) => {
    let processedValue = value;
    
    // Formatear cédula automáticamente
    if (field === 'cedula') {
      processedValue = formatCedula(value);
    }
    
    setFormData(prev => ({
      ...prev,
      informacion: { ...prev.informacion, [field]: processedValue },
    }));
  };

  const formatCedula = (cedula) => {
    if (!cedula) return '';
    
    // Solo limpiar: quitar puntos, espacios, guiones, letras
    // NO agregar formato con puntos para mantener compatibilidad con Strapi y DocVault
    const cedulaClean = cedula.replace(/[^0-9]/g, '');
    
    return cedulaClean;
  };

  return (
    <div className="modal-overlay" data-testid="create-expediente-modal">
      <div className="modal-content">
        <div className="modal-header">
          <h2>Crear Nuevo Expediente</h2>
          <button onClick={onClose} className="modal-close" data-testid="close-modal-button">×</button>
        </div>

        <form onSubmit={handleSubmit} className="modal-form">
          {error && <div className="modal-error">{error}</div>}

          <div className="form-grid">
            <div className="form-field">
              <label>Cédula *</label>
              <input type="text" required value={formData.informacion.cedula}
                onChange={(e) => handleInputChange('cedula', e.target.value)} data-testid="cedula-input" />
            </div>
            <div className="form-field">
              <label>Contrato</label>
              <input type="text" value={formData.informacion.contrato}
                onChange={(e) => handleInputChange('contrato', e.target.value)} data-testid="contrato-input" />
            </div>
            <div className="form-field">
              <label>Nombre *</label>
              <input type="text" required value={formData.informacion.nombre}
                onChange={(e) => handleInputChange('nombre', e.target.value)} data-testid="nombre-input" />
            </div>
            <div className="form-field">
              <label>Apellido *</label>
              <input type="text" required value={formData.informacion.apellido}
                onChange={(e) => handleInputChange('apellido', e.target.value)} data-testid="apellido-input" />
            </div>
            <div className="form-field">
              <label>Email</label>
              <input type="email" value={formData.informacion.email}
                onChange={(e) => handleInputChange('email', e.target.value)} data-testid="email-input" />
            </div>
            <div className="form-field">
              <label>Teléfono</label>
              <input type="text" value={formData.informacion.telefono}
                onChange={(e) => handleInputChange('telefono', e.target.value)} data-testid="telefono-input" />
            </div>
            <div className="form-field">
              <label>Sede</label>
              <input type="text" value={formData.informacion.sede}
                onChange={(e) => handleInputChange('sede', e.target.value)} data-testid="sede-input" />
            </div>
            <div className="form-field">
              <label>Estatus Cliente</label>
              <select value={formData.cliente_status}
                onChange={(e) => setFormData(prev => ({ ...prev, cliente_status: e.target.value }))} data-testid="cliente-status-select">
                {statusEnums.cliente_status.map(status => (
                  <option key={status} value={status}>{status}</option>
                ))}
              </select>
            </div>
          </div>

          <div className="modal-actions">
            <button type="button" onClick={onClose} className="btn-cancel" data-testid="cancel-button">Cancelar</button>
            <button type="submit" disabled={loading} className="btn-submit" data-testid="submit-button">
              {loading ? 'Creando...' : 'Crear Expediente'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CreateExpedienteModal;